"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-empty-state.tsx
var EmptyState = function EmptyState(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("g", {
    clipPath: "url(#clip0_2674_6071)"
  }, (0, _preact.h)("path", {
    d: "M38.5 6H10.48C8.26 6 6.52 7.78 6.52 10L6.5 38C6.5 40.2 8.26 42 10.48 42H38.5C40.7 42 42.5 40.2 42.5 38V10C42.5 7.78 40.7 6 38.5 6ZM38.5 30H30.5C30.5 33.32 27.8 36 24.5 36C21.2 36 18.5 33.32 18.5 30H10.48V10H38.5V30Z",
    fill: "#D5D6DA"
  })), (0, _preact.h)("defs", null, (0, _preact.h)("clipPath", {
    id: "clip0_2674_6071"
  }, (0, _preact.h)("rect", {
    width: "48",
    height: "48",
    fill: "white",
    transform: "translate(0.5)"
  }))));
};

var _default = EmptyState;
exports.default = _default;